export class PolicyVersions {
  static readonly cookiesPolicyLastUpdateDate = '2023-11-29';
  static readonly privacyPolicyLastUpdateDate = '2023-08-02';
}
